<template>
  <div
    class="asc-plots-viewer-wrapper"
    data-automation-id="wrapper_plots_viewer"
  >
    <asc-page-plots-wrapper
      :is-recommendation-tab="isRecommendationTab"
      :page-plots="getPagePlotsWithVisibility"
      :mini-plot="miniPlot"
      :mx-rec-plot="mxRecPlot"
      :reports-plot="reportsPlot"
      :live-chart="liveChart"
      :loading-plot-ids="loadingPlotIds"
      :chart-data="chartData"
      :editable="editable"
      :plot-editor="plotEditor"
      :saving="saving"
      :disabled="disabled"
      :hide-hidden-tabs="hideHiddenTabs"
      :plots-eyeballs-visible="plotsEyeballsVisible"
      :plots-eyeballs-readonly="plotsEyeballsReadonly"
      :on-delete-page-plot="onDeletePagePlot"
      :on-toggle-page-plot-visibility="onTogglePagePlotVisibility"
      :on-update-page-plot-caption="onUpdatePagePlotCaption"
      :on-expand="onExpand"
      :on-add-tab-to-page-plot="onAddTabToPagePlot"
      :on-remove-tab-from-page-plot="onRemoveTabFromPagePlot"
      :on-update-tab-view-page-plot="onUpdateTabViewPagePlot"
    ></asc-page-plots-wrapper>
  </div>
</template>

<script>
import AscPagePlotsWrapper from '@/components/organisms/AscPagePlotsWrapper'

export default {
  name: 'AscPlotsViewerWrapper',

  components: {
    AscPagePlotsWrapper,
  },

  props: {
    pagePlots: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    loadingPlotIds: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    plotEditor: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    visiblePlots: {
      type: Array,
      default: () => [],
    },
    miniPlot: {
      type: Boolean,
      default: false,
    },
    mxRecPlot: {
      type: Boolean,
      default: false,
    },
    reportsPlot: {
      type: Boolean,
      default: false,
    },
    liveChart: {
      type: Boolean,
      default: true,
    },
    hideHiddenTabs: {
      type: Boolean,
      default: true,
    },
    plotsEyeballsVisible: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsReadonly: {
      type: Boolean,
      default: false,
    },
    onDeletePagePlot: {
      type: Function,
      default: () => {},
    },
    onTogglePagePlotVisibility: {
      type: Function,
      default: () => {},
    },
    onUpdatePagePlotCaption: {
      type: Function,
      default: () => {},
    },
    onExpand: {
      type: Function,
      default: () => {},
    },
    onAddTabToPagePlot: {
      type: Function,
      default: () => {},
    },
    onRemoveTabFromPagePlot: {
      type: Function,
      default: () => {},
    },
    onUpdateTabViewPagePlot: {
      type: Function,
      default: () => {},
    },
    isRecommendationTab: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getPagePlotsWithVisibility() {
      const updatedPagePlots = this.pagePlots.map(pagePlot => {
        const visiblePlotIndex = this.visiblePlots?.findIndex(
          visiblePlotId => pagePlot.id === visiblePlotId,
        )
        if (visiblePlotIndex > -1) {
          return {
            ...pagePlot,
            plotVisible: true,
          }
        } else {
          return pagePlot
        }
      })

      return updatedPagePlots
    },
  },

  watch: {
    pagePlots: {
      deep: true,
      handler(pagePlots) {
        this.pagePlots = pagePlots
      },
    },
  },
}
</script>

<style lang="scss">
.asc-plots-viewer-wrapper {
  &--plots-header {
    margin: 0 0 32px 0;
  }

  h2 {
    width: 100%;
    border-bottom: 1px solid $gray-600;
    line-height: 0.1em;
    margin: 10px 0 20px 0;
    font-size: 14px;
    color: $primary-black;
    font-weight: normal;

    span {
      background: #fff;
      padding: 0 16px 0 0;
      text-transform: uppercase;
    }
  }
}
</style>
